
import { useEffect, useState } from "react";
import axios from "axios";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes.js";
import defaultLogo from "../../assets/img/auth/logo.jpg";
import { API_BASE_URL } from "../../config";

const Sidebar = ({ open, onClose }) => {
  const [logoUrl, setLogoUrl] = useState(defaultLogo);
  const [admin, setAdmin] = useState(null);
  const token = localStorage.getItem("token");

  // Fetch Admin Details
  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/admin/get-admin`,
          {
            headers: { token },
          }
        );
        const adminData = res.data?.result?.admin;
        // console.log(adminData)
        if (adminData) {
          setAdmin(adminData);
        }
      } catch (err) {
        // console.error("Error fetching admin details:", err);
      }
    };

    if (token) fetchAdmin();
  }, [token]);

  // Fetch Company Logo (your old logic)
  useEffect(() => {
    const fetchCompanyLogo = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/admin/get-companylogo`
        );

        const photoPath = res.data?.result?.profilePhoto;
        if (!photoPath) {
          setLogoUrl(defaultLogo);
          return;
        }

        let finalPath = photoPath.startsWith("http")
          ? photoPath
          : `${API_BASE_URL}${
              photoPath.startsWith("/") ? photoPath : `/${photoPath}`
            }`;

        setLogoUrl(finalPath);
      } catch (err) {
        // console.error("Error fetching company logo:", err);
        setLogoUrl(defaultLogo);
      }
    };

    fetchCompanyLogo();
  }, []);

  // ✅ Filter routes: hide Role Management if not super admin
  const filteredRoutes = routes.filter((route) => {
    if (route.name === "Role Management" && admin?.isSuperAdmin !== true) {
      return false;
    }
    return true;
  });

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      {/* Close button */}
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      {/* Logo */}
      <div className="mx-[40px] mb-2 mt-[40px] text-center">
        <img
          src={logoUrl}
          alt="Company Logo"
          onError={() => setLogoUrl(defaultLogo)}
          className="mx-auto mb-2 h-16 w-auto object-contain"
        />
        <h1 className="text-[30px] font-extrabold leading-tight tracking-wide text-indigo-700 dark:text-white">
          SWARAMAYI
        </h1>
        <div className="mt-1 text-[13px] uppercase tracking-widest text-gray-500 dark:text-gray-300">
          Real Estate Marketing
        </div>
        <div className="mx-auto mt-4 h-[2px] w-12 rounded bg-indigo-500 dark:bg-white/40" />
      </div>

      {/* Divider */}
      <div className="mb-7 mt-[20px] h-px bg-gray-300 dark:bg-white/30" />

      {/* Links */}
      <ul className="mb-auto pt-1">
        <Links routes={filteredRoutes} />
      </ul>
    </div>
  );
};

export default Sidebar;
